import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track", "dot"]

  connect() {
    this.currentIndex = 0
    this.totalSlides = this.trackTarget.children.length
    this.slidesPerView = this.getSlidesPerView()
    this.totalPositions = Math.max(1, this.totalSlides - this.slidesPerView + 1)
    this.updateDots()
    if (this.totalSlides > this.slidesPerView) {
      this.startAutoplay()
    }
    this._handleResize = this.handleResize.bind(this)
    window.addEventListener('resize', this._handleResize)
  }

  disconnect() {
    this.stopAutoplay()
    window.removeEventListener('resize', this._handleResize)
  }

  getSlidesPerView() {
    if (window.innerWidth < 768) return 1
    if (window.innerWidth < 1024) return 2
    return 3
  }

  handleResize() {
    const newSPV = this.getSlidesPerView()
    if (newSPV !== this.slidesPerView) {
      this.slidesPerView = newSPV
      this.totalPositions = Math.max(1, this.totalSlides - this.slidesPerView + 1)
      this.currentIndex = Math.min(this.currentIndex, this.totalPositions - 1)
      this.goToSlide(this.currentIndex)
    }
  }

  next() {
    this.goToSlide((this.currentIndex + 1) % this.totalPositions)
  }

  prev() {
    this.goToSlide((this.currentIndex - 1 + this.totalPositions) % this.totalPositions)
  }

  goToSlide(index) {
    this.currentIndex = index
    const pct = 100 / this.slidesPerView
    this.trackTarget.style.transform = `translateX(-${index * pct}%)`
    this.updateDots()
    this.resetAutoplay()

    // 슬라이드 전환 시 노출 추적
    const slide = this.trackTarget.children[index]
    if (slide) {
      const trackUrl = slide.getAttribute('data-ad-track-url')
      if (trackUrl && window.trackAdImpression) window.trackAdImpression(trackUrl)
    }
  }

  updateDots() {
    this.dotTargets.forEach((dot, i) => {
      dot.style.width = i === this.currentIndex ? '24px' : '8px'
      dot.style.background = i === this.currentIndex ? '#4F46E5' : '#D1D5DB'
    })
  }

  startAutoplay() {
    if (this.totalSlides > this.slidesPerView) {
      this.autoplayTimer = setInterval(() => this.next(), 5000)
    }
  }

  stopAutoplay() {
    if (this.autoplayTimer) clearInterval(this.autoplayTimer)
  }

  resetAutoplay() {
    this.stopAutoplay()
    this.startAutoplay()
  }
}
